import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'plc-footer',
	templateUrl: './footer.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'plc-footer' },
})
export class FooterComponent {
	public environment = input('');
	public year = input('');
	public version = input('');
}
